<template>
  <div class="flex justify-center bg-gray-550 text-white overflow-auto">
    <ul class="text-xs max-w-6xl w-7/8 mx-auto flex items-center">
      <li class="flex items-center">
        <nuxt-link :to="localePath('index')" class="whitespace-no-wrap">{{$t('nav.top')}}</nuxt-link>
      </li>
      <li v-for="(page, index) in list" :key="index" class="flex items-center">
        <i class="material-icons text-sm align-middle">chevron_right</i>
        <nuxt-link v-if="page.url" :to="localePath(page.url)" class="truncate">{{$t(page.name)}}</nuxt-link>
        <span v-else class="inline-block overflow-hidden">{{$t(page.name)}}</span>
      </li>
    </ul>
  </div>
</template>

<style lang="sass" scoped>
ul
  min-height: 55px
  li
    white-space: nowrap
  span
    @apply pr-5
</style>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: []
    }
  }
};
</script>